/**
 * VIB-728 I: Søk-helper for chat-rom.
 *
 * Treffer både samtale-tittel/gruppenavn OG medlemsnavn. "erik" finner
 * gruppe der Erik er medlem, selv om gruppenavnet er "Mandagsmøte".
 *
 * Bor i egen fil (ikke i ChatRoomList.tsx) for react-refresh-kompatibilitet
 * og enkel testing.
 */
import type { ChatRoom } from "@/hooks/use-chat-rooms";

export function roomTitle(room: ChatRoom, currentUserId: string): string {
  if (room.type !== "direct") return room.name ?? "Gruppe";
  const other =
    room.otherUser ?? room.members.find((m) => m.user_id !== currentUserId);
  return other?.full_name ?? "Direktemelding";
}

export function matchesSearch(
  room: ChatRoom,
  query: string,
  currentUserId: string,
): boolean {
  if (!query.trim()) return true;
  const q = query.toLowerCase().trim();
  if (roomTitle(room, currentUserId).toLowerCase().includes(q)) return true;
  return room.members.some(
    (m) =>
      m.user_id !== currentUserId &&
      (m.full_name ?? "").toLowerCase().includes(q),
  );
}
